import { Validators } from "@angular/forms";
import { Studio } from "./studio-model";

export class OpeningSlot {
  id?: number;
  day_selected: string = "";
  start_time: string = "";
  end_time: string = "";
  full_day: boolean = false;
  studio: Studio = new Studio();
  studio_name: string = "";
  studio_private_name: string = "";

  constructor(data?: Partial<OpeningSlot>) {
    if (data) {
      Object.assign(this, data);
      if (data.id !== undefined) {
        if (data.studio) {
          this.studio = new Studio(data.studio as Partial<Studio>);
        }
      }
    }
  }

  static attributeToJson(item: any) {
    let obj = item.attributes;
    obj["id"] = item.id;

    if (item.attributes.studio) {
      if (item.attributes.studio.data != null) {
        let objStudio = item.attributes.studio.data.attributes;
        objStudio["id"] = item.attributes.studio.data.id;
        obj["studio"] = objStudio;
      } else {
        obj["studio"] = null;
      }
    } else {
      obj["studio"] = null;
    }

    obj["studio_name"] = obj["studio"] != null ? ((obj["studio"].name != null && obj["studio"].name != "" && obj["studio"].name != undefined) ? obj["studio"].name : "---") : "---";
    obj["studio_private_name"] = obj["studio"] != null ? ((obj["studio"].private_name != null && obj["studio"].private_name != "" && obj["studio"].private_name != undefined) ? obj["studio"].private_name : "---") : "---";

    return obj;
  }

  static get_title() {
    return "";
  }

  static get_inputs() {
    return [
      {
        name: "full_day",
        type: "switch",
        label: "Jour entier",
        readOnly: false,
      },
      {
        name: "day_selected",
        type: "enum-object",
        label: "Jour",
        list: [
          { key: "monday", text: "Lundi" },
          { key: "tuesday", text: "Mardi" },
          { key: "wednesday", text: "Mercredi" },
          { key: "thursday", text: "Jeudi" },
          { key: "friday", text: "Vendredi" },
          { key: "saturday", text: "Samedi" },
          { key: "sunday", text: "Dimanche" }
        ],
        readOnly: false,
      },
      {
        name: "start_time",
        type: "text",
        label: "Heure de début (ex : 09:00:00)",
        readOnly: false,
      },
      {
        name: "end_time",
        type: "text",
        label: "Heure de fin (ex : 11:00:00)",
        readOnly: false,
      },
    ];
  }

  static get_form() {
    return {
      full_day: [true, Validators.required],
      day_selected: ["monday", Validators.required],
      start_time: ["", Validators.required],
      end_time: ["", Validators.required],
    };
  }

  static get_relations() {
    return [];
  }
}
